import { gql } from "@apollo/client";

export const DEPLOY = gql`
  mutation Deploy {
    deploy
  }
`;
